export var RangeDataHooks;
(function (RangeDataHooks) {
    RangeDataHooks["Label"] = "label";
    RangeDataHooks["SelectedMinValue"] = "selected-min-value";
    RangeDataHooks["SelectedMaxValue"] = "selected-max-value";
    RangeDataHooks["errorMessageWrapper"] = "errormessagewrapper-message";
})(RangeDataHooks || (RangeDataHooks = {}));
//# sourceMappingURL=types.js.map